$(document).ready(function(){


    // OPEN/CLOSE RESPONSIVE MENU

    // menu mobile open

    $('.mob_menu__button').on('click', function(event) {
        event.preventDefault();
  
        $('body').addClass('active');
        $('.responsive_wrapper').addClass('active');
      });
  
      // menu close
  
      $('.close_menu').on('click', function(event) {
            event.preventDefault();
  
            $('body').removeClass('active');
            $('.responsive_wrapper').removeClass('active');
      });


    // PLAY VIDEO

    $('.video_overlay .play_btn').on('click', function(){
        $(this).addClass('hide');

        var src = $('.video_cont').attr('data-src');

        var video = document.createElement('video');
        var source = document.createElement('source');
        source.setAttribute("src", src);
        video.appendChild(source);
        document.getElementById('video_cont').appendChild(video)

      $('.video_cont').addClass('visible');

      $('.video_cont').closest('.inner').find('.video_overlay').addClass('change');

      $(document).find('.video_cont video')[0].play();

    });

    // REVIEWS SLIDER
    
    if($('.reviews_section .slider').length){

        $('.reviews_section .slider').slick({
            slidesToShow: 1,
            arrows: true,
            prevArrow:'.reviews_section .arrow_left',
            nextArrow:'.reviews_section .arrow_right',
            dots:true,
            autoplaySpeed: 3000,
            autoplay:true,
            infinite: true,
            pauseOnHover:false
        });
    }
    
    // CLIENTS SLIDER
    
    if ($(window).width() < 1221) {
        if($('.clients_section .slider').length){

            $('.clients_section .slider').slick({
                slidesToShow: 5,
                arrows: false,
                dots:false,
                autoplaySpeed: 3000,
                autoplay:true,
                infinite: true,
                pauseOnHover:false,
                responsive: [
                    {
                      breakpoint: 769,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                      }
                    },
                    {
                        breakpoint: 601,
                        settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1
                        }
                      }
                  ]
            });
        }
    }


    // FAQ

    $('.faq_title').on('click', function(e){
        e.preventDefault();
        $(this).find('.plus_cont').toggleClass('active');
        $(this).siblings('.text').slideToggle(400);
    });

    // PRODUCT SLIDERS

    $('.product_section .top_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.product_section .bottom_slider'
      });
    
      $('.product_section .bottom_slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.product_section .top_slider',
        dots: true,
        arrows: false,
        centerMode: false,
        focusOnSelect: true
      });

      // QUESTIONS SECTION

      $('.questions_section .inner .block .title .plus_cont').on('click', function(){
        $(this).toggleClass('active');
        $(this).closest('.title').siblings('.text').toggleClass('text_hidden');
      });

      // PRODUCT CHOOSE COUNT

      $('.product_section .jars_cont a').on('click', function(e){
        e.preventDefault();

        $('.product_section .jars_cont a').removeClass('active');
        $(this).addClass('active');

        var dataItem = $(this).attr('data-item');
        var array = $('.product_section .price_cont .price');

        for (let i = 0; i < array.length; i++) {
            const element = array[i];
            if ($(element).attr('data-id') == dataItem) {
                $('.product_section .price_cont .price').removeClass('active');
                $(element).addClass('active');
            }
        }
      });

      // PLAY VIDEO

    $('.video_wrap .btn_video').on('click', function(){
        $(this).addClass('hide');

        var src = $('.video_cont').attr('data-src');

        var video = document.createElement('video');
        var source = document.createElement('source');
        source.setAttribute("src", src);
        video.appendChild(source);
        document.getElementById('video_cont').appendChild(video)

        // $('.about_us_section .video_cont').appendChild(`<video controls loop muted>
        //     <source src="`+src+`">
        // </video>`);

      $('.video_cont').addClass('visible');
      $('.video_wrap .overlay').addClass('change');

      $(document).find('.video_cont video')[0].play();

    });
   
});